import { FilterTypes } from 'Core/interfaces'

import { UrlParams, UrlParamsLabel } from 'Portals/Customer/constants'
import { Manifest, ManifestFilterFields, ManifestMainSearchFields } from 'Portals/Customer/entities'
import {
	disposalFacilityNameEntityToLabelValue,
	manifestDocumentNumbersEntityToLabelValue
} from 'Portals/Customer/utils'
import i18n from 'Portals/Customer/utils/i18nService'

export const searchConfig: Manifest.Search.Config = {
	[ManifestMainSearchFields.manifestDocumentNumber]: {
		label: i18n.t('pages:manifest.filters.manifestDocumentNumber'),
		apiFieldName: ManifestMainSearchFields.manifestDocumentNumber,
		apiSearchFieldName: 'id',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.manifestDocumentNumber,
		UrlParamLabel: UrlParamsLabel.manifestDocumentNumber,
		customOptionFormatter: manifestDocumentNumbersEntityToLabelValue
	},
	[ManifestMainSearchFields.disposalFacilityName]: {
		label: i18n.t('pages:manifest.filters.disposalFacility'),
		apiFieldName: ManifestMainSearchFields.disposalFacilityName,
		apiSearchFieldName: 'id',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.disposalFacility,
		UrlParamLabel: UrlParamsLabel.disposalFacility,
		customOptionFormatter: disposalFacilityNameEntityToLabelValue
	}
}

export const getFiltersConfig = (isSmallScreen: boolean | undefined): Manifest.Filter.Config => ({
	[ManifestFilterFields.pickupDateFrom]: {
		label: i18n.t('pages:manifest.filters.startDate'),
		apiFilterFieldName: 'PickupDateFrom',
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.startDate,
		defaultValue: null
	},
	[ManifestFilterFields.pickupDateTo]: {
		label: isSmallScreen
			? i18n.t('pages:manifest.filters.endDateMobile')
			: i18n.t('pages:manifest.filters.endDate'),
		apiFilterFieldName: 'PickupDateTo',
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.endDate,
		defaultValue: null
	},
	[ManifestFilterFields.serviceSiteId]: {
		label: i18n.t('pages:manifest.filters.serviceSiteId'),
		apiFilterFieldName: 'serviceSiteId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.serviceSiteId,
		defaultValue: ''
	}
})
